/** Shared theme for all charts. */
export const LINKS_GROWTH_THEME = {
  backgroundColor: 'transparent',
  titleColor: '#202020',
  subtitleColor: '#202020',
  textColorShow: false,
  textColor: '#202020',
  markTextColor: '#202020',
  color: ['#8ed1f0', '#0970e6', '#cfd8dc'],
  borderColor: '#e5e5e5',
  borderWidth: 0,
  legendTextColor: '#202020',
  legendItemWidth: 9,
  title: {
    padding: 0,
    left: 0,
    textStyle: {
      color: '#121212',
      fontFamily: ['Ubuntu', 'ui-sans-serif', 'system-ui'],
      fontSize: '0.875rem'
    }
  },
  legend: {
    itemWidth: 9,
    itemHeight: 9,
    padding: 0,
    itemGap: 14,
    icon: 'roundRect',
    textStyle: {
      fontFamily: ['Ubuntu', 'ui-sans-serif', 'system-ui'],
      fontSize: '0.875rem'
    }
  },
  tooltip: {
    textStyle: {
      fontFamily: ['Ubuntu', 'ui-sans-serif', 'system-ui']
    }
  }
};
